module.exports = __webpack_public_path__ + "img/th-large-solid.545570f2.svg";